// src/components/AvatarPicker.js
import { useMemo } from "react";
import "./AvatarPicker.css";

function loadAvatarsFromFolder() {
  const req = require.context("../../assets/avatars", false, /\.(png|jpe?g|svg|webp)$/i);

  return req
    .keys()
    .map((p) => {
      const mod = req(p);
      const src = mod?.default ?? mod;
      const filename = p.replace("./", "");
      const key = filename.replace(/\.[^.]+$/, "");
      return { key, src, filename };
    })
    .sort((a, b) => a.key.localeCompare(b.key));
}

export default function AvatarPicker({ value = "", onChange }) {
  const avatars = useMemo(() => loadAvatarsFromFolder(), []);

  return (
    <div className="avatar-picker">
      <div className="avatar-header">
        <div>
          <div className="avatar-title">Choose avatar</div>
          <div className="avatar-subtitle muted">Tap an avatar to select</div>
        </div>
      </div>

      <div className="avatar-grid">
        {avatars.map((a) => {
          const isSelected = a.key === value;

          return (
            <button
              key={a.key}
              type="button"
              className={`avatar-tile ${isSelected ? "is-selected" : ""}`}
              onClick={() => onChange?.(a.key)}
              title={a.key}
              aria-pressed={isSelected}
            >
              <img className="avatar-img" src={a.src} alt={a.key} />
            </button>
          );
        })}
      </div>
    </div>
  );
}